var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeDifficulty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61523 13H13.3845V14.6154C13.3845 14.8051 13.3091 14.9871 13.1749 15.1212C13.0408 15.2554 12.8588 15.3308 12.6691 15.3308H3.33062C3.14089 15.3308 2.95893 15.2554 2.82477 15.1212C2.6906 14.9871 2.61523 14.8051 2.61523 14.6154V13Z",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61645 13.0002V8.56944C1.68568 7.95405 0.693368 6.92328 0.693368 5.69251C0.692354 5.23765 0.781197 4.78707 0.954796 4.36664C1.1284 3.94621 1.38333 3.56421 1.70497 3.24257C2.0266 2.92094 2.4086 2.666 2.82903 2.4924C3.24947 2.3188 3.70005 2.22996 4.15491 2.23097C4.45612 2.23001 4.75615 2.26881 5.04721 2.34636",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9551 2.34636C11.2461 2.26881 11.5462 2.23001 11.8474 2.23097C12.3022 2.22996 12.7528 2.3188 13.1733 2.4924C13.5937 2.666 13.9757 2.92094 14.2973 3.24257C14.619 3.56421 14.8739 3.94621 15.0475 4.36664C15.2211 4.78707 15.3099 5.23765 15.3089 5.69251C15.3089 7.23097 14.732 8.48482 13.3858 8.95405V13.1541",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4388 4.53854C11.4466 4.41045 11.4466 4.28201 11.4388 4.15392C11.4388 3.23586 11.0741 2.35541 10.4249 1.70624C9.77573 1.05708 8.89527 0.692383 7.97722 0.692383C7.05916 0.692383 6.1787 1.05708 5.52954 1.70624C4.88037 2.35541 4.51568 3.23586 4.51568 4.15392C4.5078 4.28201 4.5078 4.41045 4.51568 4.53854",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.25391V9.92314",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17578 7.61523C4.19608 8.0648 4.31474 8.50445 4.52341 8.90317C4.73207 9.3019 5.02566 9.64999 5.38347 9.92293",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3078 7.61523C12.2867 8.06139 12.1708 8.49794 11.9679 8.89583C11.7649 9.29373 11.4796 9.64386 11.1309 9.92293",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeDifficulty);
export default __webpack_public_path__ + "static/media/recipe_difficulty.2c7f2592ad15cacc4736e62810bf768e.svg";
export { ForwardRef as ReactComponent };